import { TOGGLE_NAVIGATION } from './navigation.action';

export default (
    state = document.body.offsetWidth > 599,
    {
        type,
        payload,
    }: {
        type: string;
        payload: boolean | undefined;
    },
) => {
    switch (type) {
        case TOGGLE_NAVIGATION:
            return payload !== undefined ? payload : !state;
        default:
            return state;
    }
};
